import type { Entries } from 'type-fest';
import {
  leagueRoutesMap,
  LEAGUE_MODULE_NAMES,
  RoutesMap,
  DEFAULT_ROUTES_MAP,
} from './league-routes';

const checkModuleMapExists = (moduleName: LEAGUE_MODULE_NAMES) => {
  if (!Object.keys(leagueRoutesMap).includes(moduleName))
    throw Error('Passed in module name has not been mapped to a path.');
};

export const getModulePath = (moduleName: LEAGUE_MODULE_NAMES) => {
  checkModuleMapExists(moduleName);
  return leagueRoutesMap[moduleName];
};

export const setModulePath = (
  moduleName: LEAGUE_MODULE_NAMES,
  path: string,
) => {
  checkModuleMapExists(moduleName);
  leagueRoutesMap[moduleName] = path;
};

export const overwriteRoutePaths = (
  overrideRouteMap: Partial<RoutesMap>,
): void => {
  Object.keys(overrideRouteMap).forEach((key) => {
    const moduleName = key as LEAGUE_MODULE_NAMES;
    const value = overrideRouteMap[moduleName];
    if (value) {
      setModulePath(moduleName, value);
    }
  });
};

const DEFAULT_ROUTES_MAP_ENTRIES = Object.entries(
  DEFAULT_ROUTES_MAP,
) as Entries<typeof DEFAULT_ROUTES_MAP>;

/**
 * Transforms default module paths to actual configured paths.
 * Allows content to use stable default paths that work across deployments.
 */
export const processUrl = (path: string) => {
  const match = DEFAULT_ROUTES_MAP_ENTRIES.find(
    (route) => path === route[1] || path.startsWith(`${route[1]}/`),
  );

  return match
    ? path.replace(new RegExp(`^${match[1]}`), getModulePath(match[0]))
    : path;
};
